import { Component, OnInit, ViewChild, Input } from "@angular/core";
import { AChartComponent } from "../achart/achart.component";
import { ChartStokeStyle, ChartAnnotationTool, ChartMarkerType, MarkerAnchorMap } from "../achart/achart.annotation.tools";

@Component({
    selector: "chart-ctrl-panel",
    template: require('./chartPanel.component.html'),
    styles: [require('./chartPanel.component.css')]
})
export class ChartPanelComponent {
    @ViewChild("strokeWidthBtn") strokeWidthBtn: any = null;
    @ViewChild("strokeStyleBtn") strokeStyleBtn: any = null;
    @ViewChild("markerStyleBtn") markerStyleBtn: any = null;
    @ViewChild("markerSizeBtn") markerSizeBtn: any = null;

    ToolEnum=ChartAnnotationTool;
    MarkerEnum=ChartMarkerType;

    private _chartObj: any = null;
    @Input()
    public set chart(v: anychart.charts.Stock) {
        this._chartObj = v;
    }
    public get chart(): anychart.charts.Stock {
        return <anychart.charts.Stock>this._chartObj;
    }

    private _annotationToolStokeWidth: number = 1;
    public get toolLineWidth(): number {
        return this._annotationToolStokeWidth;
    }
    public set toolLineWidth(v: number) {
        this._annotationToolStokeWidth = v;
        $(this.strokeWidthBtn.nativeElement).empty();
        $(`<span><i class="ac ac-h-line-thickness-${v}"></i> ${v} px</span>`).appendTo(
            this.strokeWidthBtn.nativeElement
        );
    }

    private _strokeStyle: any = null;
    private _annotationToolStokeStyle: ChartStokeStyle = ChartStokeStyle.Solid;
    public get toolLineStyle(): ChartStokeStyle {
        return this._annotationToolStokeStyle;
    }
    public set toolLineStyle(v: ChartStokeStyle) {
        this._annotationToolStokeStyle = v;
        $(this.strokeStyleBtn.nativeElement).empty();
        let c: string =
            v === ChartStokeStyle.Solid ? "ac-h-line-thickness-2" :
                v === ChartStokeStyle.Doted ? "ac-h-line-dotted-2" : "ac-h-line-dashed-2";

        let n: string = v === ChartStokeStyle.Solid ? "Solid":
            v === ChartStokeStyle.Doted ? "Doted" : "Dashed";
        $(`<span><i class="ac ${c}"></i> ${n}</span>`).appendTo(this.strokeStyleBtn.nativeElement);
        this._strokeStyle = v === ChartStokeStyle.Solid ? null : v === ChartStokeStyle.Doted ? "1 1" : "10 5";
    }

    private _annotationTool: ChartAnnotationTool = ChartAnnotationTool.None;
    public get annotationTool(): ChartAnnotationTool {
        return this._annotationTool;
    }
    public set annotationTool(v: ChartAnnotationTool) {
        this._annotationTool = v;
        if (v === ChartAnnotationTool.None) {
            // let annotation: anychart.core.annotations.Base = this.chart.annotations().getSelectedAnnotation();
            if (this.chart) {
                this.chart
                    .annotations()
                    .unselect()
                    .cancelDrawing();
            }
        } else {
            this.startDrawing();
        }
    }

    private _annotationMarkerType: ChartMarkerType = ChartMarkerType.None;
    public get annotationMarkerType(): ChartMarkerType {
        return this._annotationMarkerType;
    }
    public set annotationMarkerType(v: ChartMarkerType) {
        this._annotationMarkerType = v;
        this._annotationTool = ChartAnnotationTool.Marker;
        this.setMarker();
        this.startDrawing();
    }


    private setMarker(): void {
        $(this.markerStyleBtn.nativeElement).empty();
        if (this.annotationTool === ChartAnnotationTool.Marker) {
            let c: string ="";
            switch (this.annotationMarkerType) {
                case ChartMarkerType.ArrowDown: c="ac-arrow-down-square";break;
                case ChartMarkerType.ArrowUp: c="ac-arrow-up-square"; break;
                case ChartMarkerType.ArrowLeft: c="ac-arrow-left-square";break;
                case ChartMarkerType.ArrowRight: c="ac-arrow-right-square";break;
                case ChartMarkerType.ArrowHead: c="ac-head-arrow";break;
                case ChartMarkerType.Cross: c="ac-cross";break;
                case ChartMarkerType.DiagonalCross: c="ac-diagonal-cros";break;
                case ChartMarkerType.Diamond: c="ac-diamond";break;
                case ChartMarkerType.Pentagon: c="ac-pentagon";break;
                case ChartMarkerType.Square: c="ac-square";break;
                case ChartMarkerType.Star10: c="ac-star-1";break;
                case ChartMarkerType.Star4: c="ac-star-2";break;
                case ChartMarkerType.Star5: c="ac-star-3";break;
                case ChartMarkerType.Star6: c="ac-star-4";break;
                case ChartMarkerType.Star7: c="ac-star-5";break;
                case ChartMarkerType.Trapezium: c="ac-trapezium";break;
                case ChartMarkerType.TriangleUp: c="ac-triangle-up";break;
                case ChartMarkerType.TriangleDown: c="ac-triangle-down";break;
                case ChartMarkerType.TriangleLeft: c="ac-triangle-left";break;
                case ChartMarkerType.TriangleRight: c="ac-triangle-right";break;
                default: c= "---";
            }
            $(`<span><i class="ac ${c}"></i>&nbsp;</span>`).appendTo(this.markerStyleBtn.nativeElement);
        } else {
            $(`<span><i class="ac"></i>---</span>`).appendTo(this.markerStyleBtn.nativeElement);
        }
    }

    private _markerSize: number = 20;
    public get markerSize(): number {
        return this._markerSize;
    }
    public set markerSize(v: number) {
        this._markerSize = v;
        $(this.markerSizeBtn.nativeElement).empty();
        $(`<span> ${v} px</span>`).appendTo(this.markerSizeBtn.nativeElement);
    }

    removeSelectedAnnotation(): void {
        if (this.chart) {
            let annotation: anychart.core.annotations.Base = this.chart.annotations().getSelectedAnnotation();
            if (annotation) {
                this.chart.annotations().removeAnnotation(annotation);
            }
        }
    }

    removeAllAnnotation(): void {
        if (this.chart) {
            this.chart.annotations().removeAllAnnotations();
        }
    }

    startDrawing(): void {
        var drawingSettings: any = {
            type: this.annotationTool,
            size: this.markerSize,
            markerType: this.annotationTool === ChartAnnotationTool.Marker ? this.annotationMarkerType : undefined,
            anchor: this.annotationTool === ChartAnnotationTool.Marker ? MarkerAnchorMap.getAnchor(this.annotationMarkerType) : undefined
            // fontSize: fontSize,
            // fontColor: fontColor
        };
        if (this.chart) {
            this.chart.annotations().startDrawing(drawingSettings);
        }
    }
}
